module.exports = __webpack_public_path__ + "img/dzbb2.23324d46.png";